var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBottomSheet',{attrs:{"value":_vm.showDialog,"content-class":"v-top-sheet","transition":"top-sheet-transition"},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }